<div class="container">
  <div class="wrapper">
    <figure>
      <img src="https://lmsassetspremium.lntedutech.com/portalicons/accessdenied.webp" alt="">
    </figure>
    <h3>Access Denied</h3>
    <p>You need permission to gain access</p>
  </div>
</div>
